import WidgetChart from '@synergy/charts';
import { Row, Col } from 'antd';
import { PageSection } from '../../styles/global/Pages.styled';

export const EnablingServices = () => {
    return (
        // Page section for enabling services
        <PageSection backgroundcolor='neutral-1'>
            {/* Row for arranging widgets */}
            <Row gutter={[16, 16]}>
                {/* Widget for horizontal bar chart */}
                <Col span={8}>
                    <WidgetChart charttype='horizontalBarChart' clickTooltipData={DUMMY_DATA} height='300px' />
                </Col>
                {/* Widget for vertical bar chart */}
                <Col span={12}>
                    <WidgetChart charttype='verticalBarChart' clickTooltipData={DUMMY_DATA} height='300px' />
                </Col>
                {/* Widget for heatmap chart */}
                <Col span={12}>
                    <WidgetChart charttype='heatmapChart' clickTooltipData={DUMMY_DATA} height='300px' />
                </Col>
            </Row>
        </PageSection>
    )
}

// DATA TOOLTIP STRUCTURE EXAMPLE

// Dummy data structure for tooltip
const DUMMY_DATA = {
    header: [
        { icon: "Lamp", title: "Titulo" }
    ],
    // Array of icon-text pairs
    iconText: [
        // Icon-text pair with calendar icon and date text
        { icon: "Calendar", text: "04-02-2022" },
        { icon: null, text: "Descrição breve" },
    ],
}
